<app-header
  [visibleActions]="false"
  [disableNavigationBtns]="true"
></app-header>

<div class="privacy" [innerHTML]="privacy()"></div>
